export default __webpack_public_path__ + "static/media/halloween-1-lq.396c0ac2.png";